<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                保障质量一致性和战略合作
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>单品供货商在“时鲜管理”中的作用至关重要，它们通过专业化供应、提高采购效率、保障质量一致性和战略合作，
                                    为企业提供了巨大的价值和竞争优势</p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/subpage.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>


    </section>
</template>

<script>
    export default {
        name: "GOODS_subpagehero"
    }
</script>

<style lang="less">


</style>